export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7605.4f11df56.jpg";